/**
 * Endpoint methods related to Customers
*/

import API from "./Api";

export default {
  /**
   * Gets all the Customers
  */
  async getCustomers() {
    return API.get("/customer/read", "COOKIE_TOKEN");
  },

  /**
   * Gets Customer specific to the Logged-In instance
  */
  async getCustomer() {

    return API.get("/customers/read", "MOODLE_SESSION_JSON");
  },

  /**
   * [PUBLIC ENDPOINT]
   * Gets all the domains registered by the Sparkfore Admin
  */
  async getDomains() {
    return API.get("/customers/domains");
  },

  /**
   * Creates New Customers
  */
  async createCustomer(form) {
    return API.post("/customer/create", form, "COOKIE_TOKEN_JSON");
  },

  /**
   * Gets Customer Checkout Session
  */
  async getCustomerCheckoutSession(id) {
    return API.get(`/payments/checkout/${id}`);
  },

  /**
   * Creates Customer Checkout Session
  */
  async createCustomerCheckoutSession(form) {
    return API.post("/payments/checkout", form);
  },

  /**
   * Creates Webshop Checkout Session
  */
  async createWebshopCheckoutSession(form) {
    return API.post("webshop/payments/checkout", form);
  },


  /**
   * Updates the Customer Data for a specific Customer ID
   */
  async updateOwnCustomer(form) {
    const customerId = form['customer']['id'];
    return API.post(`/customers/update/${customerId}`, form, "MOODLE_SESSION_JSON");
  },

  /**
   * Notifies via E-mail when a new Customer Instance has been created
   */
  async customerinstanceNotify() {

    let form = {
      "template_id": "26572748",
      "to_address": "anders.stenmark@autotech.se",
      "template_parameters": {
        "product_url": "www.facebook.com",
        "product_name": "Enterprise",
        "name": "Harshana",
        "action_url": "www.instance.sparkfore.com/login",
        "support_email": "support@sparkfore.com",
        "company_name": "Autotech Development Sweden AB",
        "company_address": "Servicegatan 1 · 931 76 Skellefteå · Sweden",
        "login_url": "www.instance.sparkfore.com/login",
        "sender_name": "Team Sparkfore",
      }
    };

    return API.post(`customerinstance/notify`, form, "COOKIE_TOKEN_JSON");
  },

  /**
   * Updates Customer Data specific to the Customer ID
   */
  async updateCustomer(form) {
    const customerId = JSON.parse(form).customerId;
    return API.put(`/customer/update/${customerId}`, form, "COOKIE_TOKEN_JSON");
  },

};
